function e(e,t){var o=t.value,a=t.selectionStart,i=t.selectionEnd;void 0!==o&&(e.value=o),void 0!==a&&void 0!==i&&e.setSelectionRange(a,i)}export{e as default};
